import type { SignupState } from '../data/types'
import { unpaidEntryLabel, unpaidEntrySummary } from '../data/signupSummary'
import { formatMoney } from '../data/format'
import styles from './ClassesFooterBar.module.css'

/** MobileClasses.dc.html's sticky bottom bar - only shown on the mobile Classes tab, and only once
 *  the racer has at least one unpaid entry (nothing to "Continue" to otherwise). Desktop has no
 *  equivalent: RegistrationCard's own sticky rail already stays visible while scrolling there. */
export function ClassesFooterBar({ signup, dollarType }: { signup: SignupState; dollarType: string }) {
  const summary = unpaidEntrySummary(signup)
  if (summary.count === 0) return null

  return (
    <div className={styles.bar}>
      <div className={styles.info}>
        <span className={styles.count}>{unpaidEntryLabel(summary)}</span>
        <span className={styles.price}>{formatMoney(summary.total, dollarType || 'USD')}</span>
      </div>
      <a href={signup.checkoutUrl} className={styles.continue}>
        Continue
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M9 6l6 6-6 6" />
        </svg>
      </a>
    </div>
  )
}
